import _ from "lodash";
import React, {useContext, useState, useEffect} from "react"

// context, data, and utils
import {ShopContext} from "../../../context/ShopContext"
import {CatalogueContext} from "../../../context/CatalogueContext"
import data from "../../../data"
import Util from "../../../util"

// components
import CheckoutItems from "./CheckoutItems"
import Checkout from "./Checkout"
import Warnings from "./Warnings"
import Addresses from "./Addresses"
import {LoadingScreen, Scaffolding} from "../../shared"
import {Checkbox, ExternalLink, Link} from "../../controls"
import {Redirect} from "react-router-dom"

// styling
import "./Confirm.scss"

// init stripe
Util.Stripe.init()

// the component
function Confirm() {
  const [mode, setMode] = useState('confirm') // either 'confirm' (default), 'paying', 'done', 'error', 'finalizing'
  const [error, setError] = useState({message:"unbekannter Fehler", source:"unbekannte Quelle"})
  //const [gatewayUrl, setGatewayUrl] = useState(null);
  const [redirectToPayment, setRedirectToPayment] = useState(false);
  // context
  const shop = useContext(ShopContext)
  const catalogue = useContext(CatalogueContext)

  const onStartPayment = async() => {
    if(data.Cart.getPaymentType() === "transfer") {
      setMode('paying')
      const result = await shop.cart.submit(null);
      if(result.ok) {
        setMode('done');
      }
      else {
        setMode("error");
        setError({message:result.errorMessage, source:"Zahlungsvorgang"});
      }
      

      // TODO we should make sure it all worked ... who knows, maybe the users's internet connection or our api is down
      
    }
    else if(data.Cart.getPaymentType() === "payrexx") {
      setRedirectToPayment(true);
    }
    else {
      const onStripeClose = () => {}
      const onStripeToken = async(token) => {
        setMode('paying')
        let response = await shop.cart.submit(token)
        if(response.ok) {
          setMode('done')
        }
        else {
          setError({source:response.errorSource || 'unbekannte Quelle', message:response.errorMessage || 'unbekannter Fehler'})
          setMode('error')
        }
        
      }
      // TODO we boldly assume stripe is ready
      // initialize payment (open stripe checkout dialog)
      Util.Stripe.pay(onStripeToken, onStripeClose)
    }
  }  

  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])

  // render loading screen if data is still loading
  if(!catalogue.isReady) {
    return null
  }

  // redirect to payment initializing 
  if(redirectToPayment) {
    return <Redirect to="/checkout/initializepayment" />
  }

  // render while paying
  if(mode === 'paying' || mode === 'finalizing') {
    return <LoadingScreen mode="paying" />
  }

  // redirect when done
  if(mode === 'done') {
    return <Redirect to="/checkout/done" />
  }

  // error if error
  if(mode === 'error') {
    let errLines
    if(error.source === "Kreditkarte" || error.source === "Payrexx") {
      errLines = (
        <>
          <p>Leider scheint die Zahlung nicht funktioniert zu haben. </p>
          <p>Deine Bestellung ist deshalb noch nicht abgeschlossen, deinem Konto wurde auch nichts belastet.</p>
          <p className="hint">Vielleicht hast du eine andere Zahlungsmöglichkeit oder du wählst beim Schritt 4 des Warenkorbs (Bezahlung &amp; Versand) einfach "Rechnung" als Zahlungsart. Dann klappt es bestimmt.</p>
          <p>
            <Link to="/checkout/payment">Zahlungsart ändern</Link>
          </p>
        </>
      )
    }
    else {
      errLines = (
        <>
          <p>
            Die Bezahlung konnte leider nicht abgeschlossen werden.
          </p>
          <p>
            Fehlerquelle: <span className="red">{error.source}</span>
          </p>
          <p>
            Fehlermeldung: <span className="red">{error.message}</span>
          </p>
        </>
      )
    }
    return (
      <Scaffolding>
        <Checkout stepName="confirm" title="Fehler beim Abwickeln der Zahlung">
          <div id="v-confirm">
            <div id="v-confirm-inner" className="error">
              {errLines}
            </div>
          </div>
        </Checkout>
      </Scaffolding>
    )
  }

  // render 
  return (
    <Scaffolding>
      <Checkout stepName="confirm" title="Bestätigen" onClickNext={onStartPayment}>
        <div id="v-confirm">
          <div id="v-confirm-inner">
            <CheckoutItems showActions={false} showShipping={true} showTotal={true} showVoucher={true} showShippingEta={false} />
            <Addresses />
            <div id="v-confirm-newsletter">
              <Checkbox
                field="Newsletter"
                onChange={(e) => data.Cart.setValue(e.field, e.checked)}
                checked={data.Cart.getValue("Newsletter") || false}
                id="v-confirm-newsletter-checkbox"
              >
                Ich möchte den Appentura-Newsletter abonnieren, um Neuigkeiten zu erfahren und von speziellen Angeboten zu profitieren
              </Checkbox>  
            </div>
            <div id="v-confirm-terms">
              <Checkbox
                field="TermsAccepted"
                required={true}
                onChange={(e) => {
                  data.Cart.setValue(e.field, e.checked)
                  let validation = data.Cart.getValidation()
                  shop.cart.setValidation(validation)
                }}
                checked={data.Cart.getValue("TermsAccepted") || false}
                id="v-confirm-terms-checkbox"
              >
                <span>Ich bin mit den </span><ExternalLink to="https://appentura.ch/agb" target="_blank">allgemeinen Geschäftsbedingungen</ExternalLink><span> einverstanden</span>
              </Checkbox>
            </div>
            <Warnings />
          </div>
        </div>
      </Checkout>
    </Scaffolding>
  )
}

export default Confirm